import React from 'react';
import { FaSearch } from 'react-icons/fa';
import InputComponent from '../../general/Input/Input';
import ButtonComponent from '../../general/Button/Button';
import './SearchAndFilter.css';

const SearchAndFilter = ({ searchTerm, onSearch }) => {
  return (
    <div className="search-container">
      <InputComponent
        type="text"
        placeholder="Digite aqui o que procura..."
        className="search-input"
        aria-label="Campo de pesquisa"
        value={searchTerm}
        onChange={(e) => onSearch(e.target.value)}
      />
      <ButtonComponent
        className="btn btn-primary search-button"
        onClick={() => onSearch(searchTerm)}
        disabled={searchTerm.trim() === ''}
      >
        <FaSearch /> Buscar
      </ButtonComponent>
    </div>
  );
};

export default SearchAndFilter;
